import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/index.css';
import './stylesheets/css/bootstrap.min.css';
import './stylesheets/scss/bootstrap-select/variables.scss';
import './stylesheets/scss/bootstrap-select/bootstrap-select.scss';
import './stylesheets/css/owl.carousel.min.css';
import './stylesheets/css/magnific-popup.css';
import './stylesheets/css/font-awesome.min.css';
import './stylesheets/css/themify-icons.css';
import './stylesheets/css/nice-select.css';
import './stylesheets/css/flaticon.css';
import './stylesheets/css/gijgo.css';
import './stylesheets/css/animate.css';
import './stylesheets/css/slick.css';
import './stylesheets/css/slicknav.css';
import './stylesheets/css/style.css';
import {App} from './dumb/App';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <React.StrictMode>
    <div id="main-container"><App /></div>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
